import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import ButtonTabs from "../../../components/Tabs/ButtonTabs";
import FinanceDashboard from "../../NewFinanceScreen/FinanceDashboard";
import AnnualPlan from "../../NewFinanceScreen/AnnualPlan";
import AccountReceivable from "../../NewFinanceScreen/AccountReceivable";
import { setActiveOfficeFinanceTab } from "../../../redux/slices/FinanceSlice";
import { useDispatch } from "react-redux";
import React from "react";

const DashboardTab = ({ noRecordFound = false, renderFilters }: { noRecordFound: boolean; renderFilters?: React.ReactNode }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { activeOfficeTab: activeTab } = useSelector((state: RootState) => state.finance);
  const buttonTabOptions = ["FINANCE DASHBOARD", "ANNUAL PLAN", "ACCOUNTS RECEIVABLE"];
  const buttonTabComponents = [
    <FinanceDashboard key="dashboard-tab" noRecordFound={noRecordFound} renderFilters={renderFilters} />,
    <AnnualPlan key="annual-tab" hideAnnualSubscribers />,
    <AccountReceivable key="acr-tab" />,
  ];
  const handleTabChange = (index: number) => {
    dispatch(setActiveOfficeFinanceTab({ index }));
  };
  return (
    <div className="">
      <div className="relative">
        <ButtonTabs
          components={buttonTabComponents}
          options={buttonTabOptions}
          activeTab={activeTab}
          onClickTab={handleTabChange}
          fromOffice={true}
        />
      </div>
    </div>
  );
};
export default DashboardTab;
